import React from 'react';
import { FieldHero, FieldMLBTeam, FieldBat } from '@helpers/FormFields';
import { BASEBALL, SOFTBALL, SPORTS_MAP } from '@constants/strings';
import { ClaimedPlayer } from '../claimedPlayer';

const PlayerFavorites: React.FC<{
  playerSports: Set<string>;
  value: ClaimedPlayer | undefined;
  updateValues: (values: Partial<ClaimedPlayer>) => void;
}> = ({ playerSports, value, updateValues }) => {
  return (
    <>
      {playerSports.size > 0 &&
        Array.from(playerSports).map((sport) => (
          // eslint-disable-next-line react/jsx-key
          <FieldHero
            key={`${sport}-hero-${value?.id}`}
            sportType={SPORTS_MAP[sport].key}
            sportDisplay={SPORTS_MAP[sport].display}
            player={value}
            updateValues={updateValues}
          />
        ))}
      {playerSports.has(BASEBALL.display) && (
        <FieldMLBTeam player={value} updateValues={updateValues} />
      )}
      {(playerSports.has(BASEBALL.display) ||
        playerSports.has(SOFTBALL.display)) && (
        <FieldBat player={value} updateValues={updateValues} />
      )}
    </>
  );
};

export default PlayerFavorites;
